import { Tab } from '../const';

/**
 * @function handleOpenTabs
 * @param { array } tabs
 * @param { string } tabId
 * @param { boolean } isUpdatedSubtab
 * @param { function } onModal
 * @returns { array }
 */
function handleOpenTabs(tabs, tabId, isUpdatedSubtab, onModal) {
	const results = tabs.map((tab) => {
		if (tab[Tab.Id] === tabId) {
			if (tab.open) {
				if (isUpdatedSubtab) {
					onModal(true);
				} else {
					return { ...tab, open: false };
				}
			} else {
				return { ...tab, open: true };
			}
		}
		return tab;
	});

	return results;
}

export default handleOpenTabs;
